import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { constantRouterMap } from './router.config'

export default createRouter({
  history: createWebHistory(),
  routes: constantRouterMap
})
